import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import EnquirePopup from './EnquirePopUp';

import '../Styles/SalaAdertise.css';

export default function SalaAdertise() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <div className='SalaAdv-Container'>
      {/* Image Side - Subtle appearance */}
      <div className='SalaAdv-left-image' data-aos="fade" data-aos-duration="1200"></div>

      {/* Text Side - Smooth fade and slide effects */}
      <div className='SalaAdv-right-text' data-aos="fade-left">
        <div
          className='SalaAdv-heading-Text-container'
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          {/* <div className='SalaAdv-Text-hr-line'></div>
          <h1 data-aos="fade-up" data-aos-delay="200">MATERIALS</h1> */}
        </div>

        <h1
          className='SalaAdv-right-h1'
          data-aos="fade-up"
          data-aos-delay="300"
        >
          Own a Villa in Coffee Estate & Heritage Resort


        </h1>

        <p
          className='SalaAdv-right-p'
          data-aos="fade-up"
          data-aos-delay="400"
        >
          It is marked to be one of its kind of resorts internationally, attracting tourists from all over the world to experience a heritage tourism like no other. The buyers of the villa will be the highest benefactors of this.
        </p>

        <p
          className='SalaAdv-right-p'
          data-aos="fade-up"
          data-aos-delay="400"
        >
          These signature spaces are more than amenities — they’re touchpoints of culture, comfort, and connection. Sala brings back the culture of the times of the Hoysalas.
        </p>

        <button
          className="SalaAdv-right-btn"
          onClick={() => setShowPopup(true)}
          data-aos="slide-up"
          data-aos-delay="500"
        >
          Enquire Now →
        </button>
      </div>

      <EnquirePopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
    </div>
  );
}
